module.exports = __webpack_public_path__ + "assets/img/pexels-christina-morillo-1181438.b24e80dc.jpg";